export default "/signup/_next/static/chunks/fonts/lineto-circular-book-9cd41ab2001e067ce8f3ab753f475200.eot";